import { Page } from '@/components/layout';
import {
  CancunUpsell,
  ExperienceSection,
  FaqSection,
  SocialProofSection,
} from '@/pages/shared/BriefBlocks';
import { HUB_FAQ, HUB_META } from './hub.content';
import { HubAzrahel } from './sections/HubAzrahel';
import { HubChamber } from './sections/HubChamber';
import { HubManifesto } from './sections/HubManifesto';
import { HubMantra } from './sections/HubMantra';
import { HubHero } from './sections/HubHero';
import { HubRoute } from './sections/HubRoute';
import { HubTestimonios } from './sections/HubTestimonios';
import styles from './TourHubPage.module.css';

/**
 * HUB de la gira (`/`) — recreacion de `DEMO_0_Hub.png`.
 *
 * Orden de secciones calcado del mockup (ADR-005 §1.1: ninguna de mas, ninguna
 * de menos): cabecera · hero · mantra · La Ruta del Despertar · La Camara
 * Cuantica Pleyadiana · Azrahel del Mayor · footer.
 *
 * `Page` ya aporta cabecera, `<main id="contenido">`, footer y el enlace de
 * salto: esta pagina solo compone sus secciones.
 *
 * El mapa seccion a seccion, con las medidas reales del PNG, esta en
 * `docs/sections/HUB_SECTION_MAP.md`. Las diferencias deliberadas respecto al
 * mockup estan en `docs/VISUAL_DEVIATIONS.md` §1.
 */
export function TourHubPage() {
  return (
    <Page
      documentTitle={HUB_META.documentTitle}
      description={HUB_META.description}
      /* El hub anula el relleno superior del `<main>` para que el cielo del hero
         llegue a y=0 y la nav se lea sobre la fotografia, como en el poster. El
         porque completo esta en `TourHubPage.module.css`. */
      className={styles.page}
    >
      <HubHero />
      <HubMantra />
      {/* El manifiesto va PEGADO al mantra y no mas abajo: el mantra es su
          primera linea. Sueltos, el lema se quedaba en cinco palabras sin
          encabezado entre el hero y la Ruta (condicion C2 del CENTINEL). */}
      <HubManifesto />
      <HubTestimonios />
      <HubRoute />
      <HubChamber />
      {/* --- Bloques exigidos por el brief, no dibujados por el mockup (ADR-006) --- */}
      <ExperienceSection />
      <HubAzrahel />
      <SocialProofSection />
      <CancunUpsell />
      {/* FAQ PROPIA del hub (`hub.content.ts`), no la de una sede: el hub vende
          la gira entera. No es dato de evento, asi que no vive en features/events. */}
      <FaqSection items={HUB_FAQ} grupo="faq-hub" />
    </Page>
  );
}
